import { Credentials } from "@tbl/aws-auth";
import sigV4Client from "./sigv4Client";
import { getServerDate } from "./systemTime";

export default function createSigV4Fetch(
  currentCredentials: () => Promise<Credentials>,
  identityIdHeader: string | null = null
) {
  return async function sigV4Fetch(
    uri: string,
    options: RequestInit
  ): Promise<Response> {
    const newHeaders = {
      ...options.headers,
      "Content-Type": options.headers["content-type"],
      Accept: "application/json",
    };
    delete newHeaders["content-type"];
    delete newHeaders["accept"];

    const credentials = await currentCredentials();

    // This value is only used when developing locally.
    if (identityIdHeader) {
      newHeaders[identityIdHeader] = credentials.identityId;
      newHeaders[`cognito-identity-id.authenticated`] =
        Object.values(credentials.params["Logins"]).length > 0;
    }
    const signedRequest = sigV4Client
      .newClient({
        accessKey: credentials.accessKeyId,
        secretKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken,
        region: "us-east-1",
        endpoint: uri,
      })
      .signRequest({
        method: options.method,
        path: "",
        headers: newHeaders,
        queryParams: null,
        body: JSON.parse(options.body?.toString() ?? "{}"),
        currentDate: await getServerDate(),
      });

    return await fetch(signedRequest.url, {
      headers: signedRequest.headers,
      method: options.method,
      body: options.body,
    });
  };
}
